'use client';

import { useEffect } from 'react';

interface HubspotFormProps {
  portalId: string;
  formId: string;
  region?: string;
  targetId?: string;
}

const HubspotForm: React.FC<HubspotFormProps> = ({
  portalId,
  formId,
  region = 'na1',
  targetId = 'hubspotForm',
}) => {
  useEffect(() => {
    const scriptId = 'hubspot-script';

    // Avoid loading the script multiple times
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.src = `https://js.hsforms.net/forms/v2.js`;
      script.async = true;
      script.defer = true;
      script.id = scriptId;

      script.onload = () => {
        (window as any).hbspt?.forms.create({
          portalId,
          formId,
          region,
          target: `#${targetId}`,
        });
      };

      document.body.appendChild(script);
    } else {
      // If already loaded
      (window as any).hbspt?.forms.create({
        portalId,
        formId,
        region,
        target: `#${targetId}`,
      });
    }
  }, [portalId, formId, region, targetId]);

  return <div id={targetId} />;
};

export default HubspotForm;
